'use client';

import Image from 'next/image';
import Link from 'next/link';

import ArrowIcon from '@/fo/icons/base/icons/arrow24.svg';
import { UiKitCarouselBase } from '@/fo/ui/kit/carousel/base';
import { utilGetLinkRel } from '@/fo/util/get-link-rel';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './Statistic.styles';

const CDN = staticMediaUrl('landing/bioderma_galchonok');

const cards = [
  {
    srcDesktop: `${CDN}/statistic1_1.png`,
    srcMobile: `${CDN}/statistic1_1_sm.png`,
    alt: 'В 2026 году партнерству BIODERMA и Фонда «ГАЛЧОНОК» исполняется 6 лет'
  },
  {
    srcDesktop: `${CDN}/statistic2_1.png`,
    srcMobile: `${CDN}/statistic2_1_sm.png`,
    alt: 'Сотрудничество BIODERMA и Фонда давно вышло за рамки ежегодной акции'
  },
  {
    srcDesktop: `${CDN}/statistic3_1.png`,
    srcMobile: `${CDN}/statistic3_1_sm.png`,
    alt: 'Благотворительный фонд «ГАЛЧОНОК»'
  },
  {
    srcDesktop: `${CDN}/statistic4.png`,
    srcMobile: `${CDN}/statistic4_sm.png`,
    alt: 'За время своей работы Фонд помог более чем 2000 семьям'
  }
];

export function Statistic({ className }: { className?: string }) {
  const slots = styles();

  return (
    <div
      className={slots.base({ className })}
      id="history"
    >
      <UiKitCarouselBase
        className={slots.cards()}
        loop={false}
        showArrows={false}
      >
        {cards.map((card) => (
          <picture
            key={card.srcDesktop}
            className={slots.card()}
          >
            <source
              srcSet={card.srcMobile}
              media="(max-width: 767px)"
            />
            <img
              className={slots.cardImage()}
              src={card.srcDesktop}
              alt={card.alt}
              width={341}
              height={500}
            />
          </picture>
        ))}
      </UiKitCarouselBase>

      <div className={slots.linkContainer()}>
        <Image
          className={slots.linkImage()}
          src={staticMediaUrl('landing/bioderma_galchonok/logo-galchonok.png')}
          alt="Bioderma Galchonok"
          width={85}
          height={71}
        />
        <div className={slots.linkWrapper()}>
          <p className={slots.linkTitle()}>
            Официальный сайт БФ&nbsp;«ГАЛЧОНОК»
          </p>
          <Link
            className={slots.link()}
            href="https://www.bf-galchonok.ru/"
            target="_blank"
            rel={utilGetLinkRel('https://www.bf-galchonok.ru/', true)}
          >
            Перейти на сайт
            <ArrowIcon />
          </Link>
        </div>
      </div>
    </div>
  );
}
